import React, { useState, useEffect } from 'react';
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { FaPlus, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import './Regulations.css';
import { useAuth } from "../../Context/AuthContext";

function Regulations() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    axios.get("/api/regulations").then(res => setFiles(res.data));
  }, []);
    
  return (
    <div className="regulations-container">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon" onClick={() => navigate("/")}>
        <IoHome title="עמוד הבית" size={30} />
      </div>
      
      <p className="title"><strong>חוקה ותקנון</strong></p>
      {user?.isAdmin && (
        <button className="regulations-add-btn" onClick={() => navigate("/regulations/new")}>
          <FaPlus /> הוספת קובץ
        </button>
      )}
      
        <div className="pdf-container">
        {files.length === 0 ? (
          <p className="no-files-message">אין קבצים להצגה</p>
        ) : (
        files.map(file => (
          <div className="pdf-card" key={file._id}>
            <button
              onClick={() => window.open(file.filePath, "_blank")}
              className="pdf-btn"
            >
              {file.title}
            </button>

            {user?.isAdmin && (
              <div className="admin-actions">
                <FaEdit
                  className="edit-icon"
                  title="עריכה"
                  onClick={() => navigate(`/regulations/edit/${file._id}`)}
                />
              </div>
            )}
          </div>
        ))
      )}
      </div>
    </div>
  );
}

export default Regulations;
